import { AnimatePresence, motion } from "framer-motion";
import { MdInfoOutline } from "react-icons/md";

interface WarningPopUpMessageProps {
  showWarningMessage: boolean;
  setShowWarningMessage: React.Dispatch<React.SetStateAction<boolean>>;
  addBreaks?: boolean;
}

/**
 * Definition of the variants of this component
 */
const variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: {
    opacity: 0,
    transition: { duration: 0.2, ease: "easeOut" },
  },
};

const WarningPopUpMessage: React.FC<WarningPopUpMessageProps> = ({
  showWarningMessage,
  setShowWarningMessage,
  addBreaks = true,
}) => {
  /**
   * Definition of the on click dismiss button
   */
  const handleOnClickDismiss = () => {
    // And remove the pop up window
    setShowWarningMessage(false);
  };

  return (
    <AnimatePresence>
      {showWarningMessage && (
        <motion.div
          className="absolute -bottom-2 w-full h-fit p-3 bg-warning-500 rounded-2xl justify-start items-center gap-3 inline-flex"
          variants={variants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="grow shrink basis-0 h-fit justify-center items-start gap-1.5 flex">
            <div className="w-6 h-6 relative">
              <MdInfoOutline className="w-full h-full fill-white" />
            </div>
            <div className="grow shrink basis-0 text-white text-sm font-normal font-sans leading-[17px]">
              Your changes are not saved yet.
              <br />
              <br />
              Once you have made your changes, please click the back button then
              use
              {addBreaks ? <br /> : " "}
              the buttons within the window to save
              {addBreaks ? <br /> : " "}
              or cancel.
            </div>
          </div>
          <div
            className="px-2 py-1 bg-warning-600 hover:bg-warning-700 ease-in-out duration-150 rounded justify-center items-center gap-2 flex cursor-pointer"
            onClick={handleOnClickDismiss}
          >
            <div className="text-white text-xs font-normal font-inter uppercase leading-[14px] tracking-wide">
              Dismiss
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default WarningPopUpMessage;
